<section class="bfa-component-wrapper" *ngIf="data?.success; else noData">
	<dl-section-header [subTitle]="subTitle" [title]="title" [asOfDate]="asOfDate"></dl-section-header>
	<bfa-accordion>
		<ng-container *ngFor="let tab of data.tabs; index as idx">
			<accordion-panel [isCollapsed]="!tab?.displayConfig?.active" *ngIf="tab?.displayConfig?.visible && tab?.displayConfig?.isIterative">
				<header>
					<ng-container
						*ngTemplateOutlet="accordionHeaderContent; context: { tab: tab.config && tab.config.id !== 'multi.asset.risk.decomposition' ? tab : decompHeaderTab }"
					></ng-container>
				</header>
				<content *ngIf="tab.config && tab.config.id === 'multi.asset.risk.characteristics'">
					<ng-container *ngIf="!tab.error; else tabError">
						<risk-characteristics-table [tab]="tab" [asOfDateSNP]="asOfDateSNP" tabId="multi.asset.risk.characteristics"></risk-characteristics-table>
						<risk-characteristic-insights *componentId="'multi.asset.risk.insights'; let res" [data]="res"></risk-characteristic-insights>
					</ng-container>
					<ng-template #tabError>
						<em class="not-applicable margin-standard" [dcrHTMLKey]="tab.error.errorCodes[0]">{{ tab.error.debugMessage }}</em>
					</ng-template>
				</content>
				<content *ngIf="tab.config && tab.config.id === 'multi.asset.risk.decomposition'">
					<risk-decomposition-table
						tabId="multi.asset.risk.decomposition"
						[decompositionTabs]="decompositionTabs"
						[totalPortfolioTab]="totalSumTab"
						[activeOnlyTab]="activeSumTab"
						[contributionTabs]="[data.tab['multi.asset.risk.decomposition.contributions']]"
					>
					</risk-decomposition-table>
					<ac-disclosure>
						<span dcrHTMLKey="MULTI_ASSET_RISK_DECOMPOSITION_DISCLAIMER">MULTI_ASSET_RISK_DECOMPOSITION_DISCLAIMER</span>
					</ac-disclosure>
				</content>
			</accordion-panel>
		</ng-container>
	</bfa-accordion>
</section>
<ng-template #noData>
	<dl-no-data [data]="data"></dl-no-data>
</ng-template>
<ng-template #accordionHeaderContent let-tab="tab">
	<dl-tooltip-section-header [tab]="tab"></dl-tooltip-section-header>
</ng-template>
